'use client';

import {useState, useEffect} from 'react';

interface ThumbnailProps extends React.ImgHTMLAttributes<HTMLImageElement> {
	fallback: string;
}

export function Thumbnail({alt, fallback, src, ...props}: ThumbnailProps) {
	const [imageSrc, setImageSrc] = useState(fallback);

	useEffect(() => {
		const img = new Image();
		img.src = src ?? '';

		img.onload = () => {
			setImageSrc(src ?? '');
		};
	}, [src]);

	return (
		<img
			{...props}
			alt={alt}
			src={imageSrc}
		/>
	);
}
